const parseSearchParams = ( searchParams ) => {
  let no = {}

  for ( let entry of searchParams.entries() ) {
    const [ key, value ] = entry

    no[ key ] = value
  }

  let onn = {}

  if ( no.with ) {
    onn = {
      ...onn,
      'TAG.with': ( JSON.parse( no.with ) ).join( '|' )
    }
    delete no.with
  }

  if ( no.level ) {
    onn = {
      ...onn,
      'TAG.level': ( JSON.parse( no.level ) ).join( '|' )
    }
    delete no.level
  }

  if ( no.setup ) {
    onn = {
      ...onn,
      'TAG.setup': ( JSON.parse( no.setup ) ).join( '|' )
    }
    delete no.setup
  }

  return { ...no, ...onn }
}

export default parseSearchParams
